import { createSelector } from 'reselect'

const eventTypeEditorSelector = (state) => state.eventTypeEditor

const isETEditorSidePanelOpenSelector = createSelector(eventTypeEditorSelector,
  ({ isETEditorSidePanelOpen }) => isETEditorSidePanelOpen
)

const eventTypePreviewDataSelector = createSelector(eventTypeEditorSelector,
  ({ eventTypePreviewData }) => eventTypePreviewData
)

const membersPreviewDataSelector = createSelector(eventTypeEditorSelector,
  ({ membersPreviewData }) => membersPreviewData
)

export {
  isETEditorSidePanelOpenSelector,
  eventTypePreviewDataSelector,
  membersPreviewDataSelector,
}
